import api from '../../api/index';

const _find_ids = (lst) => {
  let found = [];
  const re = (list= lst) => {
    for (const item of list) {
      if (Array.isArray(item)) {
        re(item);
      } else if (item && typeof item === 'object') {
        if (item.database_id) {
          found.push(item);
        } else {
          re(Object.values(item));
        }
      }
    }
  };
  re(lst);
  return found;
};

export default {
  namespaced: true,
  state     : {
    database_modal       : {},
    database_inner_modal : {},
    database_detail_modal: {
      active: false,
      name  : 'detail',
    },
    crosslink_detail_modal: {
      active: false,
      name  : 'crosslink',
    },
    improve_database_modal: {
      active: false,
    },
    improve_database_article: {
      active: false,
    },
    current_detail: {type: null, id: null},
    current_inner : {type: null, id: null},
    prev_title    : '',
    next_title    : '',
  },
  getters: {
    database_modal          : ({database_modal}) => database_modal,
    database_inner_modal    : ({database_inner_modal}) => database_inner_modal,
    current_detail          : ({current_detail}) => current_detail,
    current_inner           : ({current_inner}) => current_inner,
    prev_title              : ({prev_title}) => prev_title,
    next_title              : ({next_title}) => next_title,
    database_detail_modal   : ({database_detail_modal}) => database_detail_modal,
    crosslink_detail_modal  : ({crosslink_detail_modal}) => crosslink_detail_modal,
    improve_database_modal  : ({improve_database_modal}) => improve_database_modal,
    improve_database_article: ({improve_database_article}) => improve_database_article,
    // список карточек (объектов)
    find_ids                : ({}, {}, {}, rootGetters)=> {
      const current_list = rootGetters['database/current_list'];
      return _find_ids(current_list);
    },
  },
  mutations: {
    CLOSE_MODAL(state, modal) {
      modal.active = false;
      state.database_modal = {}
    },
    OPEN_MODAL(state, modal) {
      if (!modal.active) {
        modal.active = true;
      }
    },
    SET_DETAIL(state, value) {
      state.database_modal = value;
    },
    SET_INNER_DETAIL(state, value) {
      state.database_inner_modal = value;
    },
    SET_CURRENT(state, value) {
      state.current_detail = value;
    },
    SET_CURRENT_INNER(state, value) {
      state.current_inner = value;
    },
    SET_PREV_TITLE(state, value) {
      state.prev_title = value;
    },
    SET_NEXT_TITLE(state, value) {
      state.next_title = value;
    },
  },
  actions: {
    async get_detail({commit, getters, rootGetters}, id) {
      const {current_detail} = getters;
      let get_detail;
      try {
        if (current_detail.type=='oem') {
          get_detail = await api.database.oem_get_by_id(id);
        } else if (current_detail.type=='products') {
          get_detail = await api.database.products_get_by_id(id);
        } else if (current_detail.type=='glossary') {
          get_detail = await api.database.glossary_get_by_id(id);
        } else {
          get_detail = await api.database.classification_get_by_id(id);
        }
        commit('SET_DETAIL', get_detail.data);
      } catch (err) {
        console.error(err);
      }
    },
    async get_inner_detail({commit}, obj) {
      let {type, id} = obj;
      let get_detail;
      try {
        if (type=='oem') {
          get_detail = await api.database.oem_get_by_id(id);
        } else if (type=='products') {
          get_detail = await api.database.products_get_by_id(id);
        } else if (type=='glossary') {
          get_detail = await api.database.glossary_get_by_id(id);
        } else {
          get_detail = await api.database.classification_get_by_id(id);
        }
        commit('SET_INNER_DETAIL', get_detail.data);
      } catch (err) {
        console.error(err);
      }
    },
    next_card({dispatch}, id) {
      dispatch('get_detail', id);
    },
    prev_card({dispatch}, id) {
      dispatch('get_detail', id);
    },
  },
};
